<script setup lang="ts">
import DolphinMultiSelector from '@/components/atoms/DolphinMultiSelector.vue'
import type { InstructorSelectorQueryFragment } from './InstructorSelector.generated'
import { computed } from 'vue'

const props = defineProps<{
  payload: InstructorSelectorQueryFragment
}>()

const instructorOptions = computed(() => props.payload.kollegeInstructors)

const selectedInstructorIds = defineModel<string[]>({
  required: true,
})

const selectedInstructorOptions = computed({
  get: () =>
    instructorOptions.value.find(option =>
      selectedInstructorIds.value.includes(option.id)
    ),
  set: (
    value: InstructorSelectorQueryFragment['kollegeInstructors'][number][]
  ) => {
    selectedInstructorIds.value = value.map(option => option.id)
  },
})
</script>

<template>
  <DolphinMultiSelector
    :options="instructorOptions"
    label="name"
    track-by="id"
    v-model="selectedInstructorOptions"
    :placeholder="'講師を選択'"
    multiple
    allow-empty
    :searchable="false"
  />
</template>
